import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router'
import { Box } from '../../layout/Box'
import { SubmitButton } from '../../../styles/components/buttons'
import { ApplicationState } from '../../../store'
import { Loading } from '../../data/Loading'
import { Anchor } from '../../layout/Anchor'
import { Typography } from '../../layout/Typography'
import { RouteType } from '../../../types/routes'
import { Footer } from '../../layout/Footer'
import LoginForm from './LoginForm'
import { submitLogin } from './submitLogin'
import { useLoadSalonData } from '../../../hooks/useLoadSalonData'

type LoginProps = {
  onForgotPasswordClick: () => void
}

const LoginComponent: React.FC<LoginProps> = ({ onForgotPasswordClick }) => {
  const [email, setEmail] = useState<string>('')
  const [password, setPassword] = useState<string>('')
  const [loading, setLoading] = useState<boolean>(false)
  const [errors, setErrors] = useState<string>('')

  const history = useHistory()

  useLoadSalonData({})

  const salonGuid = useSelector((state: ApplicationState) => state.salon.data?.guid)
  const dispatch = useDispatch()

  if (!salonGuid) return null

  const handleLoginSubmit = async () => {
    setLoading(true)

    if (!email) {
      setErrors('Bitte geben Sie Ihre E-Mail-Adresse ein')
      setLoading(false)
      return
    }

    if (!password) {
      setErrors('Bitte geben Sie Ihr Passwort ein')
      setLoading(false)
      return
    }

    await submitLogin({ email, password, salonGuid, dispatch, navigate: history.push, setErrors, redirectRoute: RouteType.Profile })
    setLoading(false)
  }

  return (
    <Box>
      {loading && <Loading />}

      <LoginForm error={errors} setEmail={setEmail} setPassword={setPassword} />

      <Box margin="0 0 1rem">
        <Anchor onClick={onForgotPasswordClick}>
          <Typography variant="body1">Passwort vergessen?</Typography>
        </Anchor>
      </Box>

      <SubmitButton disabled={loading} onClick={handleLoginSubmit}>
        Login
      </SubmitButton>
      <Footer />
    </Box>
  )
}

export default LoginComponent
